import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import { SelectAllType } from './BlazeTable.types';
import i18n from '../../i18n';
import { DEFAULT_POPPER_CONFIG } from '../../constants/ui-constants';

// @ts-ignore
const SelectAllToggle = React.forwardRef(({ children, onClick }, ref: any) => (
  <button
    className="position-relative btn btn-link dropdown-toggle d-inline-block"
    ref={ref}
    onClick={e => {
      e.preventDefault();
      onClick(e);
    }}
    style={{ bottom: 8, width: 15, height: 20 }}
  />
));
SelectAllToggle.displayName = 'SelectAllDropdown';

interface SelectAllDropdownProps {
  onSelect: (selectAllType: SelectAllType) => void;
  onDeselect: () => void;
  /* Currently active selectAll type */
  selectAllType: SelectAllType | null;
  selectedItemsCount: number;
  disabled?: boolean;
}

const SelectAllDropdown = (props: SelectAllDropdownProps) => {
  return (
    <Dropdown className={'d-inline'} style={{ width: 15 }}>
      <Dropdown.Toggle as={SelectAllToggle} id="dropdown-custom-components" />
      <Dropdown.Menu popperConfig={DEFAULT_POPPER_CONFIG}>
        <Dropdown.Item
          disabled={props.disabled}
          onClick={() => {
            props.onSelect('VISIBLE');
          }}
          eventKey="1"
        >
          {i18n.t('common:selectAll.allInPage')}
        </Dropdown.Item>
        <Dropdown.Item
          disabled={props.disabled}
          onClick={() => {
            props.onSelect('ALL');
          }}
          eventKey="2"
        >
          {i18n.t('common:selectAll.all')}
        </Dropdown.Item>
        <Dropdown.Item
          disabled={(props.selectAllType === null && props.selectedItemsCount === 0) || props.disabled}
          onClick={() => {
            props.onDeselect();
          }}
          eventKey="3"
        >
          {i18n.t('common:selectAll.unselect')}
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default SelectAllDropdown;
